import React, { useContext } from "react";
import RingBar from "charts/RingBar";
import { DataContext } from "App";

const color = [
  "#7ff4f6",
  "#58baec",
  "#408bdd",
  "#275fd0",
  "#0b2fc2",
  "#c03d9f",
  "#c48bdf",
  "#f1e9f8",
];

const AdMaterial: React.FC = () => {
  const appData = useContext(DataContext);

  return <RingBar data={appData?.dimension?.display_type} color={color} />;
};

export default AdMaterial;
